import {Component, Input} from '@angular/core';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {PhonePanelProvider} from '../../../providers/phone-panel/phone-panel';
import {ContactData} from '../../../interfaces/contact-data';

@Component({
  selector: 'page-contact-details',
  templateUrl: 'contact-details.html',
  styleUrls: ['./contact-details.scss']
})
export class ContactDetailsPage {
  @Input() showHeader = true;

  selectedContact: ContactData = {} as ContactData;

  constructor(public patientDataProvider: PatientDataProvider, private phonePanelProvider: PhonePanelProvider) {
console.log("hier");
  }

  contactSelect(selectedContact) {
    this.selectedContact = selectedContact;
  }

  setPhoneContact(data) {
    this.phonePanelProvider.addressData = data.addressData;
    this.phonePanelProvider.phoneData = data.phoneData;
  }

}
